/* eslint-disable no-param-reassign */

import api from '@/services/api/department/department';

export default {
  state: {
    projectList: [],
    allDepartmentUser: [], //所有人员及所在部门信息 （用于添加人员时显示）
  },
  mutations: {
    SET_DATALIST: (state, data) => {
      state.projectList = data;
    },
    SET_DEPARTMENTUSER: (state, data) => {
      state.allDepartmentUser = data;
    },
  },
  getters: {},
  actions: {
    getDepartmentUser({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getDepartmentUser({ working_status: '在职' })
          .then((res) => {
            commit('SET_DATALIST', res)
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllDepartmentUser({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getAllDepartmentUser({})
          .then((res) => {
            commit('SET_DEPARTMENTUSER', res)
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
};
